import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './screens/HomePage';
import Layout from './components/Layout';
import Auth from './screens/Auth';
import PrivacyPolicy from './screens/PrivacyPolicy';
import TermsOfService from './screens/TermsOfService';
import JoinWaitlist from './screens/JoinWaitlist';
import HowItWorksPage from './screens/HowItWorksPage';
import SupportPage from './screens/SupportPage';
import TrustCenterPage from './screens/TrustCenterPage';
// import PricingPage from './screens/PricingPage';



// Admin Panel Part
import Dashboard from './admin/dashboard/DashboardPage';
import OffersPage from './admin/offer page/OffersPage'
import Segments from './admin/segments/SegmentPage';
import PurchasePredictor from './admin/predictor/PurchasePredictor'
import DMActivity from './admin/dm-activity/DMActivityPage';
import Attribution from './admin/attribution/AttributionPage';
import Insights from './admin/ai-insights/InsightsPage';
import ContentRevenue from './admin/content-revenue/ContentRevenuePage';
import Automations from './admin/automation/AutomationsPage';
import Integrations from './admin/integrations/IntegrationsPage';
import Settings from './admin/settings/SettingsPage';


import PublicRoute from './contexts/PublicRoute';
import AdminRoute from './contexts/AdminRoute';

import BlogPage from './screens/Blog/BlogPage';
import BlogDetailPage from './screens/Blog/BlogDetailPage';
import CreateBlog from './screens/Blog/CreateBlog';
import BlogListPage from "./screens/Blog/BlogListPage";
import EditBlogPage from "./screens/Blog/EditBlogPage";

import OAuthCallback from './screens/OAuthCallback';

import Contact from './screens/ContactPage';
import SetupIntegrations from './screens/SetupIntegrations';
import AdminDashboard from './admin/admin-dashboard/AdminDashboard';
import FacebookDelation from './screens/facebookdelation'

import FbOAuthCallback from './screens/oauth-callback/OAuthCallback';
import VerifyEmail from './screens/VerifyEmail';
import GetStartedPage from './screens/GetStartedPage';


function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />

            {/* Protected routes — redirect to login if NOT logged in */}
            <Route path="/dashboard" element={<Layout><Dashboard /></Layout>} />

            <Route path="/offer-engine" element={<Layout><OffersPage /></Layout>} />
            <Route path="/segments" element={<Layout><Segments /></Layout>} />
            <Route path="/predictor" element={<Layout><PurchasePredictor /></Layout>} />
            <Route path="/dm-activity" element={<Layout><DMActivity /></Layout>} />
            <Route path="/attribution" element={<Layout><Attribution /></Layout>} />
            <Route path="/ai-insights" element={<Layout><Insights /></Layout>} />
            <Route path="/content-revenue" element={<Layout><ContentRevenue /></Layout>} />
            <Route path="/automation" element={<Layout><Automations /></Layout>} />
            <Route path="/integrations" element={<Layout><Integrations /></Layout>} />
            <Route path="/settings" element={<Layout><Settings /></Layout>} />

            <Route path="/auth/google/callback"   element={<OAuthCallback />} />
            <Route path="/auth/facebook/callback" element={<OAuthCallback />} />
            <Route path="/auth/callback"          element={<OAuthCallback />} />
            <Route path="/auth" element={<PublicRoute><Auth /></PublicRoute>} />
            
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/facebook-terms" element={<FacebookDelation />} />
            <Route path="/verify-email" element={<VerifyEmail />} />

            <Route path="/join-waitlist" element={<JoinWaitlist />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:id" element={<BlogDetailPage />} />
            <Route path="/how" element={<HowItWorksPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/trust" element={<TrustCenterPage />} />
            
            <Route path="/blog/create" element={<AdminRoute><Layout><CreateBlog /></Layout></AdminRoute>} />
            <Route path="/blog/list" element={<AdminRoute><Layout><BlogListPage/></Layout></AdminRoute>} />
            <Route path="/blog/edit/:id" element={<AdminRoute><Layout><EditBlogPage /></Layout></AdminRoute>} />

            <Route path="/contact" element={<Contact />} />
            <Route path="/setup-integrations" element={<SetupIntegrations />} />
            <Route path="/admin-dashboard" element={<AdminRoute><Layout><AdminDashboard /></Layout></AdminRoute>} />

            <Route path="/facebook/callback" element={<FbOAuthCallback />} />

            <Route path="/getstarted" element={<Layout><GetStartedPage /></Layout>} />
           

            {/* <Route path="/pricing" element={<PricingPage />} /> */}
            
           
            
          </Routes>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}


export default App;
